import $ from 'jquery'
import { initUpload } from './form-upload.js'
import {
  DEPENDENCY_HIDDEN_INPUT_SELECTOR,
  getDependence,
  getDependencyRequiredFieldNames,
  serializeShownInputs
} from './eloqua-form/dependence.js'
import {
  addAdditionalRulesValidators,
  buildAdditionalValidationRulesAndMessages
} from './eloqua-form/additional-rules.js'

const countryCode = window.backend_properties.locale

let eloquaValidationMapping = {
  'ValidTextLength': {
    minlength: 0,
    maxlength: 100
  },
  'IsRequired': {
    required: true
  },
  'IsEmailAddress': {
    email: true
  },
  'checkbox': {
    valueNotEquals: 'default'
  },
  'singleSelect': {
    valueNotEquals: 'default'
  },
  'Phone': {
    maxlength: 50
  },
  'Currency': {
    numbersOnlyThousandSeparator: true
  },
  'multiUpload': {
    require_from_group: function () {
      return [1, '.is-multiple']
    }
  },
  'singleDate': {
    dateFormatCheck: true
  },
  'multiDateStart': {
    dateFormatCheck: true,
    multiDateStart: true
  },
  'multiDateEnd': {
    dateFormatCheck: true,
    multiDateEnd: true
  }
}

let errorMessagesMapping

let formFieldValidations = {}
let rulesObjectBlueprint = {}
let messages = {}

async function init () {
  if (window.eloquaForm) {
    await import(/* webpackChunkName: "blueimp-file-upload" */ 'blueimp-file-upload')
    await import(/* webpackChunkName: "jq-ui-widget-datepicker" */ 'jquery-ui/ui/widgets/datepicker.js')
    await import(/* webpackChunkName: "jq-validation-additional-methods" */ 'jquery-validation/dist/additional-methods.js')
    errorMessagesMapping = {
      maxlength: window.formErrors.inputMaxLength100,
      minlength: window.formErrors.default,
      unicode: window.formErrors.default,
      email: window.formErrors.email,
      required: window.formErrors.default,
      largeText: window.formErrors.inputMaxLength500,
      clock: window.formErrors.checkboxMinOne,
      maxLengthPrefix: window.formErrors.maxLengthPrefix,
      minLengthPrefix: window.formErrors.minLengthPrefix,
      numbersOnlyThousandSeparator: window.formErrors.inputNumber,
      multiUpload: window.formErrors.uploadMinOne,
      singleDate: window.formErrors.inputSingleDate,
      multiDateStart: window.formErrors.inputMultiDateStart,
      multiDateEnd: window.formErrors.inputMultiDateEnd
    }
    formFieldValidations = window.eloquaForm.validations

    $.each(formFieldValidations, function (moduleId, validations) {
      let moduleRules = rulesObjectBlueprint[moduleId] = {}

      buildValidationBlueprint(validations, moduleRules, moduleId)
      buildFormFieldErrorMessages(validations, moduleRules)
      buildDependencyRequiredMessages(moduleId)
      buildAdditionalValidationRulesAndMessages(moduleRules, messages)

      initValidation(messages)
      addAdditionalRulesValidators()
      setValidation(moduleId, validations)
      handleCallbackRequest(moduleId, validations)
      if ($('.upload-js')) {
        initUpload(window.contactEloquaPages.apiFileUpload, $('.upload-js'), window.contactEloquaPages.errorPage)
      }
    })
    handleDatepicker()
    handleTooltip()
    handleExternalSource()
    handleEloquaLocalStorage()
    handleEnterPress()
  }
}

function handleEnterPress () {
  Array.from($('form'))
    .filter(form => {
      return $(form).data('validator')
    })
    .forEach(form =>
      Array.from(form.getElementsByTagName('input'))
        .filter(tag => tag.type === 'text' || tag.type === 'email' || tag.type === 'number' || tag.type === 'date' || tag.type === 'time' || tag.type === 'datetime-local' || tag.type === 'month')
        .forEach(input => {
          input.addEventListener('keypress', (e) => {
            if (e.key === 'Enter') {
              e.stopPropagation()
              e.preventDefault()
              $(form).trigger('submit')
            }
          })
        }))
}

function handleEloquaLocalStorage () {
  if (localStorage.getItem('eloquaForm')) {
    let eloquaFormOrigin = $.parseJSON(localStorage.getItem('eloquaForm'))
    let eloquaFormNew = $.parseJSON(localStorage.getItem('eloquaForm'))
    for (const property in eloquaFormOrigin) {
      let element = $('[name=' + property + ']')
      if (element.length) {
        element.val(eloquaFormOrigin[property])
        delete eloquaFormNew[property]
      }
    }
    localStorage.eloquaForm = JSON.stringify(eloquaFormNew)
  }
}

function handleExternalSource () {
  let sourceLocalStorage = sessionStorage.getItem('source'),
    campaignParamInput = $('#CampaignParameter')

  if (campaignParamInput.length > 0 && sourceLocalStorage) {
    campaignParamInput.val(sourceLocalStorage)
  }
}

function handleCallbackRequest (moduleId, validations) {
  if (validations['CallbackTimes'] && validations['CallbackTimes']['metadata'].length > 0) {

    $(`#callback-request-${moduleId}`).on('change', function () {
      const $phoneError = $('#Phone-error'),
        $phoneTimeWrapper = $(`#phone-time-wrapper-js-${moduleId}`)

      if ($(this).find('input[type="checkbox"]').is(':checked')) {
        $phoneError.addClass('valid')
        $phoneTimeWrapper.collapse('show')
      } else {
        $phoneError.removeClass('valid')
        $phoneTimeWrapper.collapse('hide')
        $phoneTimeWrapper.find('input[type=checkbox]').prop('checked', false)
      }
      $('#Phone').valid()

      let clocks = validations['CallbackTimes']['metadata']

      $.each(clocks, function (key, value) {
        $(`#${value}`).valid()
      })
    })
  }
}

function buildFormFieldErrorMessages (formValidationDefinition, moduleRules) {
  $.each(formValidationDefinition, function (formField, validations) {
    let formFieldMessages = {}

    //handle multi checkbox[] naming
    if (validations[0].displayType === 'checkbox' && validations.metadata && validations.metadata.length > 0) {
      formField = `${formField}_multi_checkboxes[]`
    }

    let formFieldValidationBlueprint = moduleRules[formField]
    $.each(formFieldValidationBlueprint, function (key, validation) {
      let dataType = validation.dataType
      if (dataType === 'largeText' || (key === 'maxlength' && validation > 100)) {
        formFieldMessages[key] = errorMessagesMapping.largeText
      } else {
        if (key === 'maxlength' && moduleRules[formField]['maxlength'] && validation < 100) {
          formFieldMessages[key] = errorMessagesMapping.maxLengthPrefix + ' ' + moduleRules[formField]['maxlength'] + '.'
        } else if (key === 'maxLengthThousandSeparator' && moduleRules[formField]['maxLengthThousandSeparator'] && validation < 100) {
          formFieldMessages[key] = errorMessagesMapping.maxLengthPrefix + ' ' + moduleRules[formField]['maxLengthThousandSeparator'] + '.'
        } else if (key === 'minlength' && moduleRules[formField]['minlength'] && validation > 0) {
          formFieldMessages[key] = errorMessagesMapping.minLengthPrefix + ' ' + moduleRules[formField]['minlength'] + '.'
        } else {
          if (errorMessagesMapping[key]) {
            formFieldMessages[key] = errorMessagesMapping[key]
          }
        }
      }
    })
    if (formField === 'CallbackTimes') {
      $.each(validations['metadata'], function (index) {
        messages[this] = errorMessagesMapping.clock
      })
    }

    //handle multi upload
    if (formField.indexOf('upload_multiple_') != -1) {
      messages[formField + '_1'] = errorMessagesMapping['multiUpload']
      messages[formField + '_2'] = errorMessagesMapping['multiUpload']
      messages[formField + '_3'] = errorMessagesMapping['multiUpload']
    }

    //handle single date
    if (formField.indexOf('single_date_') != -1) {
      Object.assign(formFieldMessages, { dateFormatCheck: errorMessagesMapping['singleDate'] })
    }

    //handle multi date
    if (formField.indexOf('multi_date_') != -1) {
      if ($('input[name=\'' + formField + '_start\']').length > 0) {
        Object.assign(messages, { [formField + '_start']: {} })
        Object.assign(messages[formField + '_start'], { required: errorMessagesMapping['required'] }, { dateFormatCheck: errorMessagesMapping['multiDateStart'] }, { multiDateEnd: errorMessagesMapping['multiDateStart'] }, { multiDateStart: errorMessagesMapping['multiDateStart'] })
      }
      if ($('input[name=\'' + formField + '_end\']').length > 0) {
        Object.assign(messages, { [formField + '_end']: {} })
        Object.assign(messages[formField + '_end'], { required: errorMessagesMapping['required'] }, { dateFormatCheck: errorMessagesMapping['multiDateEnd'] }, { multiDateStart: errorMessagesMapping['multiDateEnd'] }, { multiDateEnd: errorMessagesMapping['multiDateEnd'] })
      }
    }

    messages[formField] = formFieldMessages
  })
}

function buildDependencyRequiredMessages (moduleId) {
  getDependencyRequiredFieldNames(moduleId).forEach(function (formField) {
    messages[formField] = Object.assign({ required: errorMessagesMapping.required }, messages[formField])
  })
}

function buildValidationBlueprint (validations, moduleRules, moduleId) {
  $.each(validations, function (fieldName, validation) {
    let rules = []

    $.each(validation, function (prop, value) {
      if ((value.displayType === 'checkbox' || value.displayType === 'singleSelect') && value.condition.type === 'IsRequired') {
        //handle multi checkbox[] naming
        if (value.displayType === 'checkbox' && validation['metadata'] && validation['metadata'].length > 0) {
          fieldName = fieldName + '_multi_checkboxes[]'
        }
        rules.push(eloquaValidationMapping[value.displayType])
        rules.push(eloquaValidationMapping[value.condition.type])
        moduleRules[fieldName] = Object.assign({}, ...rules)
        return
      }

      if (fieldName.indexOf('upload_multiple_') != -1 && value.condition.type === 'IsRequired') {
        rules.push(eloquaValidationMapping['multiUpload'])
        moduleRules[fieldName + '_1'] = Object.assign({}, ...rules)
        moduleRules[fieldName + '_2'] = Object.assign({}, ...rules)
        moduleRules[fieldName + '_3'] = Object.assign({}, ...rules)
        return
      }

      if (fieldName.indexOf('single_date_') != -1) {
        rules.push(eloquaValidationMapping['singleDate'])
        if (value.condition.type === 'IsRequired') {
          rules.push(eloquaValidationMapping[value.condition.type])
        }
        moduleRules[fieldName] = Object.assign({}, ...rules)
        return
      }

      if (fieldName.indexOf('multi_date_') != -1) {
        if ($('input[name=\'' + fieldName + '_start\']').length > 0 && $('input[name=\'' + fieldName + '_end\']').length > 0) {
          if (value.condition.type === 'IsRequired') {
            rules.push(eloquaValidationMapping[value.condition.type])
          }

          moduleRules[fieldName + '_start'] = Object.assign({}, ...rules, eloquaValidationMapping['multiDateStart'])
          moduleRules[fieldName + '_end'] = Object.assign({}, ...rules, eloquaValidationMapping['multiDateEnd'])
          return
        }

        return
      }

      if (new RegExp('.*(_kseparator).*').test(fieldName)) {
        rules.push(eloquaValidationMapping['Currency'])
        moduleRules[fieldName] = Object.assign({}, ...rules)
      }

      if (value.condition.type === 'ValidTextLength') {
        if ($('input[name=\'' + fieldName + '\']').hasClass('currency-format')) {
          rules.push({
            'minlength': parseInt(value.condition.minimum),
            'maxLengthThousandSeparator': parseInt(value.condition.maximum)
          })
          moduleRules[fieldName] = Object.assign({}, ...rules)
          return
        } else {
          eloquaValidationMapping.ValidTextLength.maxlength = parseInt(value.condition.maximum)
          eloquaValidationMapping.ValidTextLength.minlength = parseInt(value.condition.minimum)
          rules.push(eloquaValidationMapping[value.condition.type])
        }
      }
      rules.push(eloquaValidationMapping[value.condition.type])
      moduleRules[fieldName] = Object.assign({}, ...rules)
    })

    if (fieldName === 'CallbackTimes' && validation['metadata'].length > 0) {
      if (!moduleRules['Phone']) {
        moduleRules['Phone'] = {}
      }

      moduleRules['Phone']['required'] = {
        depends: function () {
          return $(`#callback-request-${moduleId}`).find('input').is(':checked')
        }
      }
      $.each(validation['metadata'], function (index) {
        moduleRules[this] = {
          require_from_group: function (element) {
            if ($(`#callback-request-${moduleId}`).find('input').is(':checked')) {
              return [1, '.phone-time']
            } else {
              return [0, '.phone-time']
            }
          }
        }
      })
    }
  })
  rulesObjectBlueprint = getDependence(moduleId, rulesObjectBlueprint)
}

function initValidation (errorMessages) {
  $.validator.setDefaults({
    debug: false,
    success: 'valid',
    messages: errorMessages
  })
  $.validator.addMethod('valueNotEquals', function (value, element, arg) {
    return arg !== value
  }, window.formErrors.dropdown)

  $.validator.addMethod('unicode', function (value, element, param) {
    return value.match(new RegExp('^[\u00C0-\u017FA-Za-z\\s\-\.]+$'))
  })

  $.validator.addMethod('numbersOnlyThousandSeparator', function (value, element, param) {
    if (value === '' || new RegExp('^[0-9]+$').test(value.replace(/[\D\s\._\-]+/g, ''))) {
      return true
    }
  })
  $.validator.addMethod('maxLengthThousandSeparator', function (value, element, param) {
    let baseRegex = '^\\d{0,param}$'
    let regex = baseRegex.replace('param', param)
    if (value === '' || new RegExp(regex).test(value.replace(/[\D\s\._\-]+/g, ''))) {
      return true
    }
  })

  $.validator.addMethod('dateFormatCheck', function (value, element, param) {
    return (new RegExp(window.eloquaForm.datepicker.dateFormatRegex)).test(value) || value === ''
  })

  $.validator.addMethod('multiDateStart', function (value, element, param) {
    let elementId = element.id,
      elementSplit = elementId.split('_start')[0],
      multiDateEnd = elementSplit + '_end',
      endDate = $('#' + multiDateEnd).val()

    if (endDate && value && datepicker.parseDate(window.eloquaForm.datepicker.dateFormat, endDate) > datepicker.parseDate(window.eloquaForm.datepicker.dateFormat, value)) {
      return true || value === ''
    } else {
      return false || value === ''
    }
  })

  $.validator.addMethod('multiDateEnd', function (value, element, param) {
    let elementId = element.id,
      elementSplit = elementId.split('_end')[0],
      multiDateStart = elementSplit + '_start',
      startDate = $('#' + multiDateStart).val()

    if (startDate && value && datepicker.parseDate(window.eloquaForm.datepicker.dateFormat, startDate) < datepicker.parseDate(window.eloquaForm.datepicker.dateFormat, value)) {
      return true || value === ''
    } else {
      return false || value === ''
    }
  })
}

let sent = false

function setValidation (moduleId, validations) {

  let $eloquaForm = $(`form[data-module="${moduleId}"]`)
  let clocks

  $eloquaForm.find('select').on('change', function (e) {
    $(this).valid()
  })

  $('.datepicker-js').on('change', function (e) {
    let $this = $(this),
      inputId = $this.attr('id')

    $(this).valid()

    if (inputId.indexOf('multi_date_') != -1 && inputId.indexOf('_end') != -1) {
      let elementSplit = inputId.split('_end')[0],
        multiDateStart = elementSplit + '_start'

      $('#' + multiDateStart).valid()
    } else if (inputId.indexOf('multi_date_') != -1 && inputId.indexOf('_start') != -1) {
      let elementSplit = inputId.split('_start')[0],
        multiDateEnd = elementSplit + '_end'

      $('#' + multiDateEnd).valid()
    }
  })

  if (validations['CallbackTimes'] && validations['CallbackTimes']['metadata']) {
    clocks = validations['CallbackTimes']['metadata']
  }

  $eloquaForm.validate({
    ignore: DEPENDENCY_HIDDEN_INPUT_SELECTOR,
    focusInvalid: false,
    onkeyup: function (element, event) {
      if ($(element).attr('name') != 'Email') {
        $(element).valid()
      }
    },
    onfocusout: function (element) {
      let elementId = $(element).attr('id')
      if (rulesObjectBlueprint[moduleId][elementId] && rulesObjectBlueprint[moduleId][elementId]['required']) {
        $(element).valid()
      }
    },
    onclick: function (element) {
      if ($(element).hasClass('formRow--checkbox')) {
        const isValid = $(element).valid()

        if ($(element).hasClass('is-multiple')) {
          let name = $(element).attr('name')
          if (isValid) {
            $(`[name="${name}"]`).removeClass('error')
          } else {
            $(`[name="${name}"]`).addClass('error')
          }
        }
      }
    },
    rules: rulesObjectBlueprint[moduleId],
    errorPlacement: function (error, $element) {
      let name = $element.attr('name')

      if (clocks && clocks.indexOf(name) !== -1) {
        if (!$eloquaForm.find('.phone-time-error').find('.error').length) {
          error.appendTo($('.phone-time-error'))
        }
      } else if ($element.hasClass('is-multiple')) {
        $(`[name="${name}"]`).addClass('error')
        if (!$element.closest('.is-multiple-wrapper').find('.error-wrapper').find('.error').length) {
          error.appendTo($element.closest('.is-multiple-wrapper').find('.error-wrapper'))
        }
      } else {
        error.insertAfter($element)
      }
    },
    invalidHandler: function (form, validator) {
      if (!validator.numberOfInvalids()) {
        return
      }

      // 50px for better look
      let headerHeight = $('header').height() + 50

      let $element = $(validator.errorList[0].element)
      if ($(validator.errorList[0].element).hasClass('upload-url')) {
        $element = $(validator.errorList[0].element).parent()
      }

      let errorLabels = $('Label.error')

      for (let i = 0; i < validator.errorList.length; i++) {
        let errorElement = $(validator.errorList[i].element)

        for (let j = 0; j < errorLabels.length; j++) {
          if (!$(errorLabels[j]).hasClass('valid') && $(errorLabels[j]).parents(errorElement).length != 1) {
            $(errorLabels[j]).addClass('valid')
          }
        }
      }

      $('html, body').animate({
        scrollTop: ($element.offset().top - headerHeight)
      }, 1000)
    },
    submitHandler: function (form) {
      if (!sent) {
        sent = true
        $eloquaForm.find('[type=submit]').prop('disabled', true).css('cursor', 'wait')

        document.body.style.cursor = 'wait'
        $.ajax({
          url: form.action,
          method: 'POST',
          data: serializeShownInputs(form),
          success: function (response, statusText, xhr) {

            let successPage

            if (xhr.status == 200) {
              successPage = window.contactEloquaPages.successPage.toLocaleLowerCase()
            } else if (xhr.status == 400 || xhr.status == 403) {
              location.href = window.contactEloquaPages.errorPage.toLocaleLowerCase()
            }

            if (localStorage.getItem('contact.pageSource')) {
              let pageSource = localStorage.getItem('contact.pageSource')
              let start,
                end,
                product

              // if URL end with trailing-slash remove it
              if (pageSource.match(/\/$/)) {
                pageSource = pageSource.slice(0, -1)
              }

              start = pageSource.lastIndexOf('/') + 1
              end = pageSource.length
              product = pageSource.substring(start, end)

              successPage += '?source=' + product
            }

            const requestInterest = $(form).find('#RequestInterest').val() || ''
            const requestTopic = $(form).find('#RequestTopic').val() || ''

            const eventText = (!requestInterest && !requestTopic) ? 'NoTopic' : requestInterest + ' ' + requestTopic

            sendTrackingEventToTrackingManager(eventText)

            localStorage.removeItem('contact.pageSource')
            window.location.href = successPage
          },
          error: function (jqXHR, textStatus, errorThrown) {
            window.location.href = window.contactEloquaPages.errorPage
          }
        })
      }
    }
  })
}

function sendTrackingEventToTrackingManager (eventText) {
  const event = new CustomEvent('eloqua-form-sent', { detail: eventText })
  document.dispatchEvent(event)
}

function handleDatepicker () {
  let datepickerInput = $('.datepicker-js')

  datepickerInput.each(function () {
    $(this).datepicker({ dateFormat: window.eloquaForm.datepicker.dateFormat, showAnim: '' })
  })

  $(window).resize(function () {
    let activeInput = $(document.activeElement)
    if (activeInput.is('.hasDatepicker')) {
      activeInput.datepicker('hide').datepicker('show')
    }
  })
}

function handleTooltip () {
  let tooltipElements = $('[data-bs-toggle=\'tooltip\']'),
    tooltipIcon = $('.tooltip-icon')

  for (let i = 0; i < tooltipElements.length; i++) {
    let tooltipContainer = $(tooltipElements[i]).find('.tooltip-icon')

    $(tooltipElements[i]).tooltip({
      trigger: 'manual',
      container: tooltipContainer
    })
  }

  tooltipIcon.hover(function () {
      $(this).parents('[data-bs-toggle=\'tooltip\']').tooltip('show')
    }, function () {
      $(this).parents('[data-bs-toggle=\'tooltip\']').tooltip('hide')
    }
  )

  tooltipIcon.click(function () {
    $(this).parents('[data-bs-toggle=\'tooltip\']').tooltip('show')
  })

  $('body').on('click', function (e) {
    if (!$(e.target).is('.tooltip-icon')) {
      tooltipElements.tooltip('hide')
    }
  })
}

export default { init }
